export default __webpack_public_path__ + "static/media/home.8fafbc83.png";